// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('orderHeadCapJob', {
//         templateUrl: 'views/components/views/orderHeadCapJob/orderHeadCapJob.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'orderHeadCapJobService', 'ttGridFactory', function ($stateParams, stateService, utilityService, translateService, modalService, orderHeadCapJobService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orderInternalNo = $stateParams.order_internal_no;

//             let progressionInfo = {
//                 label: '',
//                 plabel: '',
//                 field: '',
//                 remField: '',
//                 min: 0,
//                 max: 100,
//                 step: 0,
//                 finishclose: '',
//                 runProgress: ''
//             }

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 gridReady: false,
//                 settingCapacityJob: {},
//                 lockedBackward: false,
//                 lockedForward: false
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: '',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.settingCapacityJob = (await orderHeadCapJobService.getOrderHeadCapJob({ order_internal_no: orderInternalNo }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 if (utilityService.validateParmsValue(vm.model.settingCapacityJob.view_id) === true) {
//                     vm.grid.dataTask.rememberId = vm.model.settingCapacityJob.view_id;

//                     if (utilityService.validateParmsValue(vm.model.settingCapacityJob.p2_datatask_keyno) === true) {
//                         vm.grid.dataTask.loadData = {
//                             method: vm.model.settingCapacityJob.p2_datatask_keyno,
//                             parameters: vm.model.settingCapacityJob
//                         };

//                         vm.model.gridReady = true;

//                         if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                     }
//                 }
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region PROGRESSBAR FUNCTION

//             function activateProgressBackward(items) {
//                 let increment = 1, skip = 0, failed = 0, step = 0;
//                 progressionInfo.step = 0;

//                 function doStep() {
//                     setTimeout(() => {
//                         modalService.progressInfo.finishclose = '0';
//                         if (progressionInfo.runProgress === 'ABORT') return;

//                         if (progressionInfo.step >= progressionInfo.max) {
//                             return;
//                         }

//                         step = progressionInfo.step + skip + failed;
//                         progressionInfo.field = 'ID: ' + items[step].orderline_keyno;
//                         modalService.progressInfo.field = progressionInfo.field;

//                         orderHeadCapJobService.addProduction({
//                             orderline_keyno: items[step].orderline_keyno,
//                             capjob_keyno: items[step].capjob_keyno,
//                             lastdt_production_finish: vm.model.settingCapacityJob.lastdt_production_finish,
//                             direction: 'B'
//                         }).then((response) => {
//                             if (response[0] && response[0].errorcode !== '0') {
//                                 modalService.show({
//                                     type: 'warning',
//                                     title: translations.error,
//                                     message: response[0].errormessage,
//                                     buttons: [{
//                                         label: translations.ok,
//                                         cssClass: 'btn-warning',
//                                         action: (dialogItself) => {
//                                             modalService.progressInfo.finishclose = '1';
//                                             progressionInfo.runProgress = 'ABORT';
//                                             modalService.progressInfo.abortclose = true;
//                                             doStep();
//                                             dialogItself.close();
//                                         }
//                                     }]
//                                 });
//                             } else {
//                                 progressionInfo.step += increment;
//                                 modalService.progressInfo.step = progressionInfo.step;
//                                 modalService.progressInfo.finishclose = progressionInfo.finishclose;

//                                 doStep();
//                             }
//                         });
//                     });
//                 }

//                 doStep();
//             }

//             function progressFuncBackward() {
//                 progressionInfo.runProgress = 'START';
//                 progressionInfo.label = 'progressbar';
//                 //progressionInfo.plabel = 'progressbar';
//                 progressionInfo.field = '';
//                 //progressionInfo.remField = '';
//                 //progressionInfo.min = 0;
//                 progressionInfo.max = 0;
//                 progressionInfo.step = 0;
//                 progressionInfo.finishclose = '1';
//                 progressionInfo.abortclose = false;
                
//                 let currentData = vm.grid.gridfunc.getAllRows();

//                 progressionInfo.max = currentData.length;
//                 activateProgressBackward(currentData);

//                 modalService.showProgress(progressionInfo).then(function (value) {
//                     progressionInfo.runProgress = value;

//                     if (progressionInfo.runProgress === 'ABORT') {
//                         vm.model.lockedBackward = false;
//                     } else if (progressionInfo.runProgress === 'FINISH') {
//                         vm.model.lockedBackward = false;
//                         loadGrid();
//                     }
//                 });
//             }

//             function activateProgressForward(items) {
//                 let increment = 1, skip = 0, failed = 0, step = 0;
//                 progressionInfo.step = 0;

//                 function doStep() {
//                     setTimeout(() => {
//                         modalService.progressInfo.finishclose = '0';
//                         if (progressionInfo.runProgress === 'ABORT') return;

//                         if (progressionInfo.step >= progressionInfo.max) {
//                             return;
//                         }

//                         step = progressionInfo.step + skip + failed;
//                         progressionInfo.field = 'ID: ' + items[step].orderline_keyno;
//                         modalService.progressInfo.field = progressionInfo.field;

//                         orderHeadCapJobService.addProduction({
//                             orderline_keyno: items[step].orderline_keyno,
//                             capjob_keyno: items[step].capjob_keyno,
//                             lastdt_production_finish: vm.model.settingCapacityJob.lastdt_production_finish,
//                             direction: 'F'
//                         }).then((response) => {
//                             if (response[0] && response[0].errorcode !== '0') {
//                                 modalService.show({
//                                     type: 'warning',
//                                     title: translations.error,
//                                     message: response[0].errormessage,
//                                     buttons: [{
//                                         label: translations.ok,
//                                         cssClass: 'btn-warning',
//                                         action: (dialogItself) => {
//                                             modalService.progressInfo.finishclose = '1';
//                                             progressionInfo.runProgress = 'ABORT';
//                                             modalService.progressInfo.abortclose = true;
//                                             doStep();
//                                             dialogItself.close();
//                                         }
//                                     }]
//                                 });
//                             } else {
//                                 progressionInfo.step += increment;
//                                 modalService.progressInfo.step = progressionInfo.step;
//                                 modalService.progressInfo.finishclose = progressionInfo.finishclose;

//                                 doStep();
//                             }
//                         });
//                     });
//                 }

//                 doStep();
//             }

//             function progressFuncForward() {
//                 progressionInfo.runProgress = 'START';
//                 progressionInfo.label = 'progressbar';
//                 //progressionInfo.plabel = 'progressbar';
//                 progressionInfo.field = '';
//                 //progressionInfo.remField = '';
//                 //progressionInfo.min = 0;
//                 progressionInfo.max = 0;
//                 progressionInfo.step = 0;
//                 progressionInfo.finishclose = '1';
//                 progressionInfo.abortclose = false;

//                 let currentData = vm.grid.gridfunc.getAllRows();

//                 progressionInfo.max = currentData.length;
//                 activateProgressForward(currentData);

//                 modalService.showProgress(progressionInfo).then(function (value) {
//                     progressionInfo.runProgress = value;

//                     if (progressionInfo.runProgress === 'ABORT') {
//                         vm.model.lockedForward = false;
//                     } else if (progressionInfo.runProgress === 'FINISH') {
//                         vm.model.lockedForward = false;
//                         loadGrid();
//                     }
//                 });
//             }

//             // #endregion PROGRESSBAR FUNCTION

//             // #region ACTIVATE MULTI BUTTON FUNCTIONS

//             vm.activateFunc = function (action) {
//                 switch (action) {
//                     case 'backward':
//                         if (utilityService.validateParmsValue(vm.model.settingCapacityJob.order_internal_no) !== true) return;

//                         vm.model.lockedBackward = true;

//                         orderHeadCapJobService.deletePrevious({ order_internal_no: vm.model.settingCapacityJob.order_internal_no }).then((response) => {
//                             if (response[0] && response[0].errorcode !== '0') {
//                                 modalService.show({
//                                     type: 'warning',
//                                     title: translations.error,
//                                     message: response[0].errormessage,
//                                     buttons: [{
//                                         label: translations.ok,
//                                         cssClass: 'btn-warning',
//                                         action: (dialogItself) => {
//                                             dialogItself.close();
//                                             vm.model.lockedBackward = false;
//                                         }
//                                     }]
//                     	        });
//                             } else {
//                                 progressFuncBackward();
//                             }
//                         });
//                         break;
//                     case 'forward':
//                         if (utilityService.validateParmsValue(vm.model.settingCapacityJob.order_internal_no) !== true) return;

//                         vm.model.lockedForward = true;

//                         orderHeadCapJobService.deletePrevious({ order_internal_no: vm.model.settingCapacityJob.order_internal_no }).then((response) => {
//                             if (response[0] && response[0].errorcode !== '0') {
//                                 modalService.show({
//                                     type: 'warning',
//                                     title: translations.error,
//                                     message: response[0].errormessage,
//                                     buttons: [{
//                                         label: translations.ok,
//                                         cssClass: 'btn-warning',
//                                         action: (dialogItself) => {
//                                             dialogItself.close();
//                                             vm.model.lockedForward = false;
//                                         }
//                                     }]
//                     	        });
//                             } else {
//                                 progressFuncForward();
//                             }
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion ACTIVATE MULTI BUTTON FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadSetting();
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
